import { render } from "./PatientReportResultValues.vue?vue&type=template&id=da257d4a"
import script from "./PatientReportResultValues.vue?vue&type=script&lang=js"
export * from "./PatientReportResultValues.vue?vue&type=script&lang=js"

import "./PatientReportResultValues.vue?vue&type=style&index=0&id=da257d4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__